import loadable from '~/components/utils/lazyImport';

export default loadable(() => import('./index'));
